// extracted by mini-css-extract-plugin
module.exports = {"wholePage":"Layout_wholePage__wh5or","mainContent":"Layout_mainContent__eQZ0t","extraWide":"Layout_extraWide__8_loL","mainContainer":"Layout_mainContainer__hLb_a"};